import { Button, EButtonType } from '../Button';

export interface IProps {
    onClick: () => void;
    heading: string;
    id: string;
    text: string | { __html: string };
    showErrors: boolean;
}

export const testId = 'SummarySection';

export function SummarySection({
    onClick,
    heading,
    id,
    text,
    showErrors,
}: IProps): JSX.Element {
    return (
        <div
            data-testid={testId}
            className={`border bg-white p-4 rounded-lg my-1 ${showErrors && 'bg-error'}`}
        >
            <div className='_flex justify-between items-center'>
                <h3 className="w-full font-bold text-sm">
                    {heading}
                </h3>
                <div>
                    <Button
                        type={EButtonType.EDIT_BUTTON_OCR_SUMMARY_SECONDARY_OUTLINE}
                        onClick={onClick}
                        id={id}
                    >
                        Edit
                    </Button>
                </div>
            </div>
            <p
                className="pt-2 text-textBody text-[13px]"
                dangerouslySetInnerHTML={
                    typeof text === 'string'
                        ? { __html: text }
                        : { __html: text.__html }
                }
            ></p>
        </div>
    );
}
